import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(5),
      minWidth: '120px',
      display:'flex',
      flexDirection:'row'
    },
    table: {
        width: 150,
      },
      root: {
        // flexDirection:'row',
        maxWidth: '600px',
        //justifyContent:'space-between',
        marginBottom:10,
        
        // display: 'flex',
        // flexWrap: 'wrap',
        // '& > *': {
        //   margin: theme.spacing(1),
        //   height: theme.spacing(10),
        // },
        
      },
      roleStyle:{
         paddingTop:30,
         fontWeight:'bold',
         width:'55%',
         alignSelf:'center',
         //border:'solid 1px',
         //borderColor:'red'
      },
      Icon:{
        width:30,
        alignSelf:'center',
        cursor:'pointer'
      },
      hierarchyStyle:{
          display:'flex',
          flexDirection:'row'
      },
      imageStyle:{
        width:150,
        alignSelf:'center',
        cursor:'pointer'
      },
      textBoxStyle:{
        fontWeight:'bold',
        paddingLeft:theme.spacing.unit,
      },
      typography: {
        padding: theme.spacing(2),
      },
      colorStyle:{
        cursor:'pointer',
        width:40,
        height:40,
        borderRadius:80/2,
        marginBottom:10
      }
      
}))
export default useStyles